import { cdcEventModule, cdcEventType } from '@tempo-io/common-dto';
import { discriminatedUnion, z } from 'zod';

export const creditEventDTOSchema = z.object({
  id: z.string(),
  organizationId: z.string(),
  createdAt: z.string(),
  amount: z.number(),
  kind: z.enum(['consumption', 'topup']),
  operationType: z.string().nullable(),
  description: z.string().nullable(),
  actorUserId: z.string().nullable(),
  metadata: z.record(z.string(), z.unknown()),
});

const idModuleSchema = z.object({
  module: z.literal(cdcEventModule.enum.id),
});

export const creditEventDataChangeDTOSchema = discriminatedUnion('eventType', [
  idModuleSchema.extend({
    entityType: z.literal('credit_event'),
    eventType: z.literal(cdcEventType.enum.created),
    entity: creditEventDTOSchema,
  }),
]);

export type CreditEventDTO = z.infer<typeof creditEventDTOSchema>;
